import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  Tabs,
  Tab,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import React, { useState, useEffect, useCallback } from "react";
import { get, post } from "../../../../utils/api";
import BulkUploadAdd from "./BulkUploadAdd";
import BulkFileUpload from "./BulkFileUpload";
import {
  NATURAL_GAS_QUANTITY_UNIT_SET,
  NATURAL_GAS_DEFAULT_QUANTITY_UNIT,
  mapNaturalGasBulkRows,
  mapStationaryBulkHoursRows,
  PROPANE_BULK_DENSITY_COLUMN,
} from "./naturalGasBulkRowNormalize";
const BulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  bulkUploadTable,
  onOpenAddEquipment,
  bulkuploadInputData,
  url,
  fuelType,
  submitUrl,
  title,
  keyValue,
  options,
  addNew,
  setFormData,
  formData,
  jsonBulkUpload = [],
  bulkUploadUrl,
  setsnackOpen,
  fieldName,
  densityRequiredUnits,
}) => {
  const [expandedRows, setExpandedRows] = useState({});
  const [errors, setErrors] = useState({});
  const [equipmentList, setEquipmentList] = useState([]);
  const [matchedKey, setMatchedKey] = useState(matchData);
  const [finalJson, setFinalJson] = useState(jsonBulkUpload);
  const [activeTab, setActiveTab] = useState(0);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] =
    useState(false);
  // Document upload confirmation state for each tab
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState({
    cumulative: false,
    individual: false,
  });
  // Separate document upload state for each tab
  const [documentUploadType, setDocumentUploadType] = useState({
    cumulative: "none", // "none", "individual", "same"
    individual: "none",
  });
  const [commonDocument, setCommonDocument] = useState({
    cumulative: null,
    individual: null,
  });
  const [individualDocuments, setIndividualDocuments] = useState({
    cumulative: {},
    individual: {},
  });
  // State to track if user wants to proceed without documents
  const [proceedWithoutDocuments, setProceedWithoutDocuments] = useState({
    cumulative: false,
    individual: false,
  });
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);
  // State to track which tabs need document confirmation
  const [tabsNeedingConfirmation, setTabsNeedingConfirmation] = useState({
    cumulative: false,
    individual: false,
  });


  useEffect(() => {
    if (!jsonBulkUpload?.length) return;
    setFinalJson(
      jsonBulkUpload.map((tab) => ({
        ...tab,
        data: densityRequiredUnits?.length
          ? mapNaturalGasBulkRows(tab?.data || [])
          : mapStationaryBulkHoursRows(tab?.data || []),
      })),
    );
  }, [jsonBulkUpload, densityRequiredUnits]);

  // Check if we have tabbed data structure
  const isTabbedData =
    Array.isArray(matchData) && matchData.length > 0 && matchData[0].type;

  // Get current tab data
  const getCurrentTabData = () => {
    if (isTabbedData) {
      return {
        matchData: matchData[activeTab]?.data || [],
        jsonData: jsonBulkUpload[activeTab]?.data || [],
        formData: formData[activeTab]?.data || {},
      };
    }
    return {
      matchData: matchData || [],
      jsonData: jsonBulkUpload || [],
      formData: formData || {},
    };
  };

  const currentTabData = getCurrentTabData();

  useEffect(() => {
    if (options) {
      setEquipmentList(options);
    } else {
      fetchEquipmentList();
    }
  }, [url, options]);

  const fetchEquipmentList = async () => {
    const response = await get(url);
    // const names = response.data?.data?.map((item) => item?.name);
    setEquipmentList(response.data.data);
  };

  const getRowQuantityUnit = (row) => {
    const canonical = String(row?.quantityConsumedUnit ?? "").trim();
    if (canonical && NATURAL_GAS_QUANTITY_UNIT_SET.has(canonical)) {
      return canonical;
    }
    if (
      canonical &&
      !Number.isNaN(Number(canonical)) &&
      Number.isFinite(Number(canonical))
    ) {
      return NATURAL_GAS_DEFAULT_QUANTITY_UNIT;
    }
    const unit =
      row?.["Unit of Quantity Consumed"] ??
      row?.quantityConsumed?.unit ??
      row?.["Quantity Consumed Unit"];
    if (unit != null && String(unit).trim() !== "") {
      const u = String(unit).trim();
      if (NATURAL_GAS_QUANTITY_UNIT_SET.has(u)) return u;
    }
    if (
      row?.["Quantity Consumed (in M3)"] != null &&
      String(row["Quantity Consumed (in M3)"]).trim() !== ""
    ) {
      return NATURAL_GAS_DEFAULT_QUANTITY_UNIT;
    }
    return "";
  };

  const getRowQuantityValue = (row) => {
    const value =
      row?.["Quantity Consumed"] ??
      row?.["Quantity Consumed (in M3)"] ??
      row?.quantityConsumed?.value;
    return value != null ? String(value).trim() : "";
  };

  const getRowDensityValue = (row) => {
    const direct =
      row?.Density ??
      row?.density ??
      row?.[PROPANE_BULK_DENSITY_COLUMN];
    if (direct != null && String(direct).trim() !== "") {
      return String(direct).trim();
    }
    const canonical = String(row?.quantityConsumedUnit ?? "").trim();
    const raw = row?.["Unit of Quantity Consumed"];
    const unitCell =
      raw !== undefined && raw !== null && raw !== ""
        ? String(raw).trim()
        : "";

    // quantityConsumedUnit wrongly holds density (e.g. "10")
    if (
      canonical &&
      !NATURAL_GAS_QUANTITY_UNIT_SET.has(canonical) &&
      !Number.isNaN(Number(canonical)) &&
      Number.isFinite(Number(canonical))
    ) {
      return String(Number(canonical));
    }

    if (
      canonical &&
      NATURAL_GAS_QUANTITY_UNIT_SET.has(canonical) &&
      unitCell &&
      unitCell !== canonical &&
      !Number.isNaN(Number(unitCell))
    ) {
      return String(Number(unitCell));
    }
    return "";
  };

  const validateDensityForRows = (rows, tabLabel) => {
    if (!densityRequiredUnits?.length || !Array.isArray(rows)) return [];

    return rows.reduce((errors, row, index) => {
      const unit = getRowQuantityUnit(row);
      const quantity = getRowQuantityValue(row);
      if (!quantity || !densityRequiredUnits.includes(unit)) return errors;

      const density = getRowDensityValue(row);
      if (density === "" || Number.isNaN(Number(density))) {
        errors.push(
          `${tabLabel} row ${index + 1}: Density is required when unit is ${unit}.`
        );
      }
      return errors;
    }, []);
  };

  const validateUploadData = useCallback(() => {
    const validationErrors = [];

    if (isTabbedData) {
      // Check both tabs separately
      const cumulativeData = matchData[0]?.data || [];
      const individualData = matchData[1]?.data || [];
      const cumulativeFormData = formData[0]?.data || {};
      const individualFormData = formData[1]?.data || {};

      // Check Cumulative tab (tab 0)
      const cumulativeUnmatched = cumulativeData.filter((item, index) => {
        const isMatched = item.matched;
        const isSelected =
          cumulativeFormData[index]?.selectedEquipment &&
          cumulativeFormData[index]?.selectedEquipment !== "" &&
          cumulativeFormData[index]?.selectedEquipment !== "add_new";
        return !isMatched && !isSelected;
      });

      // Check Individual tab (tab 1)
      const individualUnmatched = individualData.filter((item, index) => {
        const isMatched = item.matchedUniqueId && item.matched;
        const isSelected =
          (individualFormData[index]?.selectedEquipment !== "add_new" &&
            individualFormData[index]?.selectedEquipment) ||
          individualFormData[index]?.selectedUniqueId;
        return !isMatched && !isSelected;
      });

      // Add specific error messages
      if (cumulativeUnmatched.length > 0 && individualUnmatched.length > 0) {
        validationErrors.push(
          "Both Cumulative and Individual data have unmatched items. Please match or select all items in both tabs."
        );
      } else if (cumulativeUnmatched.length > 0) {
        validationErrors.push(
          "Cumulative data has unmatched items. Please match or select all Cumulative data entries."
        );
      } else if (individualUnmatched.length > 0) {
        validationErrors.push(
          "Individual data has unmatched items. Please match or select all Individual data entries."
        );
      }

      // Check document upload type validation for both tabs (keep this validation)
      // Check Cumulative tab document upload type
      if (
        documentUploadConfirmed.cumulative &&
        documentUploadType.cumulative === "none"
      ) {
        validationErrors.push(
          "Cumulative data: Please select a document upload type when document upload is confirmed."
        );
      }

      // Check Individual tab document upload type
      if (
        documentUploadConfirmed.individual &&
        documentUploadType.individual === "none"
      ) {
        validationErrors.push(
          "Individual data: Please select a document upload type when document upload is confirmed."
        );
      }

      // Document upload validation removed - allow proceeding without documents
    } else {
      // For non-tabbed data, check current tab
      const currentTabKey = activeTab === 0 ? "cumulative" : "individual";
      if (
        documentUploadConfirmed[currentTabKey] &&
        documentUploadType[currentTabKey] === "none"
      ) {
        validationErrors.push(
          "Please select a document upload type when document upload is confirmed."
        );
      }

      // Document upload validation removed - allow proceeding without documents
    }

    const dataToValidate =
      finalJson && finalJson.length > 0 ? finalJson : jsonBulkUpload;

    if (densityRequiredUnits?.length && dataToValidate?.length) {
      if (isTabbedData) {
        validationErrors.push(
          ...validateDensityForRows(
            dataToValidate[1]?.data || [],
            "Individual"
          )
        );
      } else {
        validationErrors.push(
          ...validateDensityForRows(dataToValidate, "Upload")
        );
      }
    }

    return validationErrors;
  }, [
    isTabbedData,
    matchData,
    formData,
    documentUploadConfirmed,
    documentUploadType,
    activeTab,
    currentTabData,
    finalJson,
    jsonBulkUpload,
    densityRequiredUnits,
  ]);

  // Removed continuous validation - now only validates on confirm button click

  // Function to clear specific validation errors based on the type of change
  const clearSpecificErrors = (errorTypesToClear) => {
    if (hasValidationBeenAttempted && uploadValidationErrors.length > 0) {
      const remainingErrors = uploadValidationErrors.filter((error) => {
        return !errorTypesToClear.some((errorType) =>
          error.includes(errorType)
        );
      });
      setUploadValidationErrors(remainingErrors);

      // If all errors are cleared, reset the validation attempted flag
      if (remainingErrors.length === 0) {
        setHasValidationBeenAttempted(false);
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setExpandedRows({}); // Reset expanded rows when switching tabs
  };

  const handleDocumentUploadConfirmation = (confirmed) => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setDocumentUploadConfirmed((prev) => ({
      ...prev,
      [tabKey]: confirmed,
    }));

    // Clear specific validation errors when document upload confirmation changes
    if (hasValidationBeenAttempted) {
      clearSpecificErrors([
        "Please select a document upload type",
        "Cumulative data: Please select a document upload type",
        "Individual data: Please select a document upload type",
      ]);
    }

    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType((prev) => ({
        ...prev,
        [tabKey]: "none",
      }));
    }
  };

  const handleDocumentUploadTypeChange = (event) => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setDocumentUploadType((prev) => ({
      ...prev,
      [tabKey]: event.target.value,
    }));

    // Clear specific validation errors when document upload type changes
    if (hasValidationBeenAttempted) {
      clearSpecificErrors([
        "Please select a document upload type",
        "Cumulative data: Please select a document upload type",
        "Individual data: Please select a document upload type",
      ]);
    }

    setCommonDocument((prev) => ({
      ...prev,
      [tabKey]: null,
    }));
    setIndividualDocuments((prev) => ({
      ...prev,
      [tabKey]: {},
    }));
  };

  const handleCommonDocumentChange = (files) => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setCommonDocument((prev) => ({
      ...prev,
      [tabKey]: files,
    }));

    // Update finalJson with common document for all entries
    // const currentJsonData = currentTabData.jsonData;
    const currentJsonData = finalJson?.[activeTab]?.data;
    if (currentJsonData && currentJsonData.length > 0) {
      const updated = currentJsonData.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));

      if (isTabbedData) {
        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data: updated,
          };
          return newData;
        });
      } else {
        setFinalJson(updated);
      }
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setIndividualDocuments((prev) => ({
      ...prev,
      [tabKey]: {
        ...prev[tabKey],
        [index]: files,
      },
    }));

    // Update finalJson with individual document for specific entry
    // const currentJsonData = currentTabData.jsonData;
    const currentJsonData = finalJson?.[activeTab]?.data;
    if (currentJsonData && currentJsonData.length > 0) {
      const updated = currentJsonData.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": files,
          };
        }
        return entry;
      });

      if (isTabbedData) {
        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data: updated,
          };
          return newData;
        });
      } else {
        setFinalJson(updated);
      }
    }
  };

  const handleClearCommonDocument = () => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setCommonDocument((prev) => ({
      ...prev,
      [tabKey]: null,
    }));

    // Update finalJson to clear common document for all entries
    // const currentJsonData = currentTabData.jsonData;
    const currentJsonData = finalJson?.[activeTab]?.data;
    if (currentJsonData && currentJsonData.length > 0) {
      const updated = currentJsonData.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));

      if (isTabbedData) {
        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data: updated,
          };
          return newData;
        });
      } else {
        setFinalJson(updated);
      }
    }
  };

  const handleClearIndividualDocument = (index) => {
    const tabKey = activeTab === 0 ? "cumulative" : "individual";
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[tabKey][index];
      return newDocs;
    });

    // Update finalJson to clear individual document for specific entry
    // const currentJsonData = currentTabData.jsonData;
    const currentJsonData = finalJson?.[activeTab]?.data;
    if (currentJsonData && currentJsonData.length > 0) {
      const updated = currentJsonData.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });

      if (isTabbedData) {
        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data: updated,
          };
          return newData;
        });
      } else {
        setFinalJson(updated);
      }
    }
  };

  const handleProceedWithoutDocuments = () => {
    setProceedWithoutDocuments((prev) => ({
      ...prev,
      cumulative: tabsNeedingConfirmation.cumulative ? true : prev.cumulative,
      individual: tabsNeedingConfirmation.individual ? true : prev.individual,
    }));
    setShowNoDocumentDialog(false);
    setTabsNeedingConfirmation({ cumulative: false, individual: false });
    performUpload();
  };
  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  if (!matchData || matchData.length === 0) {
    return null;
  }

  const handleFormChange = (index, field, value) => {
    let fieldName;
    if (field === "selectedEquipment") {
      fieldName = title === "Machinery Name" ? "Machinery" : "Equipment";
    } else if (field === "selectedUniqueId") {
      fieldName = title === "Machinery Name" ? "Unique ID of Machinery" : "Unique ID of Equipment";
    } else {
      fieldName = field;
    }
      
    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              [field]: value,
            },
          },
        },
      }));
      setFinalJson((prev) => {
        const newData = [...(prev || [])];
        newData[activeTab] = {
          ...newData[activeTab],
          data:
            newData[activeTab]?.data?.map((item, i) =>
              i === index ? { ...item, [fieldName]: value } : item
            ) || [],
        };
        return newData;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        },
      }));
    }

    // If "Add New Equipment" is selected, expand the row
    if (field === "selectedEquipment" && value === "add_new") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: true,
      }));
    }

    // If any other equipment is selected, close the expanded row and clear form fields (but keep selectedEquipment)
    if (
      (field === "selectedEquipment" && value !== "add_new" && value !== "") ||
      (field === "selectedUniqueId" && value !== "")
    ) {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form fields but keep the selectedEquipment value
      if (isTabbedData) {
        setFormData((prev) => ({
          ...prev,
          [activeTab]: {
            ...prev[activeTab],
            data: {
              ...prev[activeTab]?.data,
              [index]: {
                ...prev[activeTab]?.data?.[index],
                [field]: value,
              },
            },
          },
        }));
        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data:
              newData[activeTab]?.data?.map((item, i) =>
                i === index ? { ...item, [fieldName]: value } : item
              ) || [],
          };
          return newData;
        });
      } else {
        setFormData((prev) => ({
          ...prev,
          [index]: {
            [field]: value,
          },
        }));

        setFinalJson((prev) => {
          const newData = [...(prev || [])];
          newData[activeTab] = {
            ...newData[activeTab],
            data:
              newData[activeTab]?.data?.map((item, i) =>
                i === index ? { ...item, [fieldName]: value } : item
              ) || [],
          };
          return newData;
        });
      }
    }
    if (field === "selectedEquipment" && value !== "" && value !== "add_new") {
      if (isTabbedData) {
        setMatchData((prev) =>
          prev.map((tab, tabIndex) =>
            tabIndex === activeTab
              ? {
                  ...tab,
                  data: tab.data.map((item, i) =>
                    i === index && !item.matched
                      ? { ...item, updatedKey: value }
                      : item
                  ),
                }
              : tab
          )
        );
      } else {
        setMatchData((prev) =>
          prev.map((item, i) =>
            i === index && !item.matched ? { ...item, updatedKey: value } : item
          )
        );
      }

      // (optional) keep the parallel matchedKey state in sync
      setMatchedKey((prev) =>
        prev.map((item, i) =>
          i === index && !item.matched
            ? { ...item, updatedKey: value, updatedMatch: true }
            : item
        )
      );
    }

    // Clear specific validation errors when form data changes (after validation has been attempted)
    if (hasValidationBeenAttempted) {
      clearSpecificErrors([
        "unmatched items",
        "Cumulative data has unmatched items",
        "Individual data has unmatched items",
        "Both Cumulative and Individual data have unmatched items",
      ]);
    }

    // Clear validation errors when equipment or unique ID is selected
    if (
      (field === "selectedEquipment" && value !== "" && value !== "add_new") ||
      (field === "selectedUniqueId" && value !== "")
    ) {
      // Check if all unmatched items are now selected
      const currentData = getCurrentTabData();
      const allUnmatchedSelected = currentData.matchData
        .map((item, idx) => ({ item, idx }))
        .filter(({ item }) =>
          activeTab === 1
            ? !item.matchedUniqueId || !item.matched
            : !item.matched
        )
        .every(({ idx }) => {
          const selected =
            activeTab === 1
              ? (currentData.formData[idx]?.selectedEquipment !== "add_new" &&
                  currentData.formData[idx]?.selectedEquipment) ||
                currentData.formData[idx]?.selectedUniqueId
              : currentData.formData[idx]?.selectedEquipment &&
                currentData.formData[idx]?.selectedEquipment !== "" &&
                currentData.formData[idx]?.selectedEquipment !== "add_new";
          return selected && (selected !== "" || selected === "add_new");
        });

      // If all unmatched items are selected, clear validation errors
      if (allUnmatchedSelected) {
        setUploadValidationErrors([]);
      }
    }

    console.log(fieldName, "fieldName",field, "field",value, "value", finalJson, "finalJson");
  };
  console.log(finalJson, "finalJson");

  const handleItemAdded = (index, machineryName, uniqueIds = []) => {
    setFinalJson((prev) => {
      const newData = [...(prev || [])];
      
      // Determine the correct field name based on title
      const fieldName = title === "Machinery Name" ? "Machinery Name" : "Equipment";
      
      newData[activeTab] = {
        ...newData[activeTab],
        data:
          newData[activeTab]?.data?.map((item, i) => {
            if (i === index) {
              const updatedItem = { ...item, [fieldName]: machineryName };
              
              // For Individual tab with Machinery Name, also update the Unique ID field
              if (title === "Machinery Name" && activeTab === 1 && uniqueIds.length > 0) {
                updatedItem["Unique ID of Machinery"] = uniqueIds[0];
              }
              return updatedItem;
            }
            return item;
          }) || [],
      };
      return newData;
    });

    // Clear specific validation errors when new item is added
    if (hasValidationBeenAttempted) {
      clearSpecificErrors([
        "unmatched items",
        "Cumulative data has unmatched items",
        "Individual data has unmatched items",
        "Both Cumulative and Individual data have unmatched items",
      ]);
    }
  };

  const validateForm = (index) => {
    const data = isTabbedData
      ? formData[activeTab]?.data?.[index] || {}
      : formData[index] || {};
    const newErrors = {};

    if (!data?.location) {
      newErrors.location = "Location is required";
    }
   
    if (title === "Machinery Name") {
      if (!data.numberOfMachines || data.numberOfMachines <= 0) {
        newErrors.numberOfMachines = "Valid number of machines is required";
      }
      if (!data?.machines?.length || data?.machines?.length === 0) {
        newErrors.equipments = "At least one machinery is required";
      }
      if (!data?.machineCategory) {
        newErrors.machineCategory = "Machinery category is required";
      }
      if (!data?.machineType) {
        newErrors.machineType = "Machinery type is required";
      }
      if (!data?.fuelType) {
        newErrors.fuelType = "Fuel type is required";
      }
    } else {
      if (!data?.equipmentType) {
        newErrors.equipmentType = "Equipment type is required";
      }
      if (!data?.industrialProcess) {
        newErrors.industrialProcess = "Industrial process is required";
      }
      if (!data.noOfEquipment || data.noOfEquipment === 0) {
        newErrors.noOfEquipment = "No of equipment is required";
      }
    }
    // Validate each equipment form
    data?.equipments?.forEach((equipment, eqIndex) => {
      if (!equipment.uniqueID || equipment.uniqueID.trim() === "") {
        newErrors[`equipment_${eqIndex}_uniqueID`] = `Unique ID is required.`;
      }
      if (!equipment.brand || equipment.brand.trim() === "") {
        newErrors[`equipment_${eqIndex}_brand`] = `Brand is required.`;
      }
      if (!equipment.model || equipment.model.trim() === "") {
        newErrors[`equipment_${eqIndex}_model`] = `Model is required.`;
      }
      if (
        !equipment.ratedFuelConsumption ||
        equipment.ratedFuelConsumption.trim() === ""
      ) {
        newErrors[
          `equipment_${eqIndex}_ratedFuelConsumption`
        ] = `Rated Fuel Consumption is required.`;
      }
    });

    console.log(data?.machines, "data?.machines");

    // Validate each machine form
    data?.machines?.forEach((machine, mIndex) => {
      if (!machine.uniqueID || machine.uniqueID.trim() === "") {
        newErrors[`machine_${mIndex}_uniqueID`] = `Unique ID is required.`;
      }
      if (!machine.brand || machine.brand.trim() === "") {
        newErrors[`machine_${mIndex}_brand`] = `Brand is required.`;
      }
      if (!machine.model || machine.model.trim() === "") {
        newErrors[`machine_${mIndex}_model`] = `Model is required.`;
      }
      if (
        !machine.ratedFuelConsumption ||
        machine.ratedFuelConsumption.trim() === ""
      ) {
        newErrors[
          `machine_${mIndex}_ratedFuelConsumption`
        ] = `Rated Fuel Consumption is required.`;
      }
    });

    console.log(newErrors, "newErrors");

    setErrors((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const performUpload = async () => {
    // Use jsonBulkUpload as fallback if finalJson is empty
    const dataToUse =
      finalJson && finalJson.length > 0 ? finalJson : jsonBulkUpload;

    // Prepare data structure for dual sheets
    let uploadData;

    const normalizeRows = (rows) => {
      const list = Array.isArray(rows) ? rows : [];
      return densityRequiredUnits?.length
        ? mapNaturalGasBulkRows(list)
        : mapStationaryBulkHoursRows(list);
    };

    if (isTabbedData && dataToUse.length >= 2) {
      // Structure for tabbed data (Cumulative and Individual sheets)
      uploadData = {
        excelData: {
          cumulative: normalizeRows(dataToUse[0]?.data || []),
          individual: normalizeRows(dataToUse[1]?.data || []),
        },
        documentUploadType: documentUploadType,
        commonDocument: commonDocument,
        individualDocuments: individualDocuments,
      };
    } else {
      // Fallback for non-tabbed data or single sheet
      const currentTabKey = activeTab === 0 ? "cumulative" : "individual";
      const rawRows = Array.isArray(dataToUse) ? dataToUse : [];
      uploadData = {
        excelData: normalizeRows(rawRows),
        documentUploadType: documentUploadType[currentTabKey],
        commonDocument: commonDocument[currentTabKey],
        individualDocuments: individualDocuments[currentTabKey],
      };
    }

    console.log("Final upload data structure:", uploadData);

    await post(bulkUploadUrl, uploadData)
      .then((res) => {
        // Clear validation errors and reset validation attempted flag on successful upload
        setUploadValidationErrors([]);
        setHasValidationBeenAttempted(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onConfirm();
        onClose();
      })
      .catch((err) => {
        const errMessage = err.response?.data?.details
          ?.map((el) => el?.error)
          ?.join(",");
        if (err?.response?.status === 422) {
        }
        setsnackOpen({
          open: true,
          message: errMessage ?? err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    if (isTabbedData) {
      const cumulativeNeedsDocs =
        documentUploadConfirmed.cumulative &&
        documentUploadType.cumulative !== "none";
      const individualNeedsDocs =
        documentUploadConfirmed.individual &&
        documentUploadType.individual !== "none";

      let cumulativeHasDocs = false;
      let individualHasDocs = false;

      if (cumulativeNeedsDocs) {
        const hasCommonDoc =
          documentUploadType.cumulative === "same" &&
          commonDocument.cumulative &&
          commonDocument.cumulative.length > 0;
        const hasIndividualDocs =
          documentUploadType.cumulative === "individual" &&
          Object.keys(individualDocuments.cumulative).length > 0 &&
          Object.values(individualDocuments.cumulative).some(
            (docs) => docs && docs.length > 0
          );
        cumulativeHasDocs = hasCommonDoc || hasIndividualDocs;
      }

      if (individualNeedsDocs) {
        const hasCommonDoc =
          documentUploadType.individual === "same" &&
          commonDocument.individual &&
          commonDocument.individual.length > 0;
        const hasIndividualDocs =
          documentUploadType.individual === "individual" &&
          Object.keys(individualDocuments.individual).length > 0 &&
          Object.values(individualDocuments.individual).some(
            (docs) => docs && docs.length > 0
          );
        individualHasDocs = hasCommonDoc || hasIndividualDocs;
      }

      // Show dialog if documents are needed but not uploaded
      if (
        (cumulativeNeedsDocs && !cumulativeHasDocs) ||
        (individualNeedsDocs && !individualHasDocs)
      ) {
        setTabsNeedingConfirmation({
          cumulative: cumulativeNeedsDocs && !cumulativeHasDocs,
          individual: individualNeedsDocs && !individualHasDocs,
        });
        setShowNoDocumentDialog(true);
        return;
      }
    } else {
      // For non-tabbed data
      const currentTabKey = activeTab === 0 ? "cumulative" : "individual";
      const needsDocs =
        documentUploadConfirmed[currentTabKey] &&
        documentUploadType[currentTabKey] !== "none";

      if (needsDocs) {
        const hasCommonDoc =
          documentUploadType[currentTabKey] === "same" &&
          commonDocument[currentTabKey] &&
          commonDocument[currentTabKey].length > 0;
        const hasIndividualDocs =
          documentUploadType[currentTabKey] === "individual" &&
          Object.keys(individualDocuments[currentTabKey]).length > 0 &&
          Object.values(individualDocuments[currentTabKey]).some(
            (docs) => docs && docs.length > 0
          );

        if (!hasCommonDoc && !hasIndividualDocs) {
          setTabsNeedingConfirmation({
            cumulative: currentTabKey === "cumulative",
            individual: currentTabKey === "individual",
          });
          setShowNoDocumentDialog(true);
          return;
        }
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  const allMatched = currentTabData.matchData.every((item) =>
    activeTab === 1 ? item.matchedUniqueId && item.matched : item.matched
  );

  const allUnmatchedSelected = currentTabData.matchData
    .map((item, idx) => ({ item, idx }))
    .filter(({ item }) =>
      activeTab === 1 ? !item.matchedUniqueId || !item.matched : !item.matched
    )
    .every(({ idx }) => {
      const selected =
        activeTab === 1
          ? (currentTabData.formData[idx]?.selectedEquipment !== "add_new" &&
              currentTabData.formData[idx]?.selectedEquipment) ||
            currentTabData.formData[idx]?.selectedUniqueId
          : currentTabData.formData[idx]?.selectedEquipment &&
            currentTabData.formData[idx]?.selectedEquipment !== "" &&
            currentTabData.formData[idx]?.selectedEquipment !== "add_new";
      // Must be non-empty and not "Tap to Select"
      console.log(selected, "selected");
      return selected && (selected !== "" || selected === "add_new");
    });

  const confirmButtonEnabled =
    allMatched ||
    (currentTabData.matchData.some((item) =>
      activeTab === 1 ? !item.matchedUniqueId : !item.matched
    ) &&
      allUnmatchedSelected);

  return (
    <>
      <Dialog
        open={bulkUploadTable}
        onClose={onClose}
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            width: "70%",
            margin: "16px",
            maxHeight: "calc(100% - 32px)",
            zIndex: 1000,
          },
        }}
      >
        <DialogTitle>
          {isTabbedData
            ? `Review Bulk Upload Data - ${
                matchData[activeTab]?.type || "Unknown"
              } Entry`
            : "Review Bulk Upload Data"}
        </DialogTitle>
        <DialogContent>
          {isTabbedData && (
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
              <Tabs value={activeTab} onChange={handleTabChange}>
                <Tab label="Cumulative Data Entry" />
                <Tab label="Individual Data Entry" />
              </Tabs>
            </Box>
          )}

          <Typography variant="body2" sx={{ mb: 2 }}>
            Review the matched and unmatched equipment data. Add unmatched items
            individually.
            {isTabbedData && (
              <span style={{ fontWeight: "bold", color: "#1976d2" }}>
                {" "}
                ({matchData[activeTab]?.type} Data)
                {activeTab === 1 && " - Includes Unique ID matching"}
              </span>
            )}
          </Typography>

          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "30%",
                    }}
                  >
                    Data Entered
                  </TableCell>
                  {isTabbedData && activeTab === 1 && (
                    <TableCell sx={{ width: "18%" }}></TableCell>
                  )}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "20%",
                    }}
                  >
                    Master Data
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: isTabbedData && activeTab === 1 ? "20%" : "20%",
                    }}
                  >
                    {title ? title : "Equipment Name"}
                  </TableCell>
                  {isTabbedData && activeTab === 1 && (
                    <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                      Unique ID
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: isTabbedData && activeTab === 1 ? "15%" : "20%",
                    }}
                  >
                    {title ? title : "Equipment Name"}
                  </TableCell>
                  {isTabbedData && activeTab === 1 && (
                    <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                      Unique ID
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: isTabbedData && activeTab === 1 ? "20%" : "20%",
                    }}
                  >
                    Action
                  </TableCell>
                  {documentUploadConfirmed[
                    activeTab === 0 ? "cumulative" : "individual"
                  ] &&
                    documentUploadType[
                      activeTab === 0 ? "cumulative" : "individual"
                    ] === "individual" && (
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          width: "15%",
                        }}
                      >
                        Document
                      </TableCell>
                    )}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentTabData.matchData.map((item, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell>
                        {keyValue ? item?.[keyValue] : item.equipment}
                      </TableCell>

                      {isTabbedData && activeTab === 1 && (
                        <TableCell>
                          {item.uniqueID || item.uniqueId || "N/A"}
                        </TableCell>
                      )}
                      <TableCell>
                        {item.matched ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "10.5rem", maxWidth: "10.5rem" }}
                          >
                            <Select
                              value={
                                currentTabData.formData[index]
                                  ?.selectedEquipment || ""
                              }
                              onChange={(e) =>
                                handleFormChange(
                                  index,
                                  "selectedEquipment",
                                  e.target.value
                                )
                              }
                              fullWidth
                              displayEmpty
                              disabled={item.matched}
                            >
                              <MenuItem value="" disabled>
                                Tap to Select
                              </MenuItem>
                              {addNew !== false && (
                                <MenuItem value="add_new">
                                  {title === "Machinery Name"
                                    ? "Add New Machinery +"
                                    : "Add New Equipment +"}
                                </MenuItem>
                              )}
                              {equipmentList &&
                                equipmentList.map((item, index) => {
                                  return (
                                    <MenuItem value={item?.name}>
                                      {item?.name}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                      {isTabbedData && activeTab === 1 && (
                        <TableCell>
                          {item.matchedUniqueId ? (
                            <Chip
                              label="Matched"
                              color="success"
                              size="small"
                            />
                          ) : (
                            <FormControl
                              size="small"
                              sx={{ minWidth: "7rem", maxWidth: "7rem" }}
                            >
                              <Select
                                value={
                                  currentTabData.formData[index]
                                    ?.selectedUniqueId || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    "selectedUniqueId",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                displayEmpty
                                disabled={item.matchedUniqueId}
                              >
                                <MenuItem value="" disabled>
                                  Tap to Select
                                </MenuItem>
                                {item?.matched
                                  ? item?.validUniqueIds?.map(
                                      (uniqueId, idx) => {
                                        return (
                                          <MenuItem key={idx} value={uniqueId}>
                                            {uniqueId}
                                          </MenuItem>
                                        );
                                      }
                                    )
                                  : equipmentList &&
                                    equipmentList
                                      .find(
                                        (el) =>
                                          el?.name ===
                                            currentTabData.formData[index]
                                              ?.selectedEquipment || ""
                                      )
                                      ?.equipments?.map((el) => el.uniqueID)
                                      ?.map((uniqueId, idx) => {
                                        return (
                                          <MenuItem key={idx} value={uniqueId}>
                                            {uniqueId}
                                          </MenuItem>
                                        );
                                      })}
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                      )}
                      <TableCell>
                        {!item.matched &&
                          (currentTabData.formData[index]?.selectedEquipment ===
                            "add_new" || expandedRows[index] ? (
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => {
                                setExpandedRows((prev) => ({
                                  ...prev,
                                  [index]: !prev[index],
                                }));
                              }}
                              sx={{ minWidth: "80px" }}
                            >
                              {expandedRows[index] ? "Close" : "Open"}
                            </Button>
                          ) : null)}
                      </TableCell>
                      {documentUploadConfirmed[
                        activeTab === 0 ? "cumulative" : "individual"
                      ] &&
                        documentUploadType[
                          activeTab === 0 ? "cumulative" : "individual"
                        ] === "individual" && (
                          <TableCell>
                            <BulkFileUpload
                              filesList={
                                individualDocuments[
                                  activeTab === 0 ? "cumulative" : "individual"
                                ][index] || []
                              }
                              handleChange={handleIndividualDocumentChange}
                              handleClear={handleClearIndividualDocument}
                              index={index}
                            />
                          </TableCell>
                        )}
                    </TableRow>
                    {/* Expandable form row */}
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={
                          isTabbedData && activeTab === 1
                            ? documentUploadConfirmed[
                                activeTab === 0 ? "cumulative" : "individual"
                              ] &&
                              documentUploadType[
                                activeTab === 0 ? "cumulative" : "individual"
                              ] === "individual"
                              ? 6
                              : 5
                            : documentUploadConfirmed[
                                activeTab === 0 ? "cumulative" : "individual"
                              ] &&
                              documentUploadType[
                                activeTab === 0 ? "cumulative" : "individual"
                              ] === "individual"
                            ? 4
                            : 3
                        }
                      >
                        <Collapse
                          in={expandedRows[index]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <BulkUploadAdd
                            index={index}
                            formData={formData}
                            errors={errors}
                            setErrors={setErrors}
                            validateForm={validateForm}
                            setFormData={setFormData}
                            setMatchData={setMatchData}
                            setExpandedRows={setExpandedRows}
                            bulkuploadInputData={bulkuploadInputData}
                            fuelType={fuelType}
                            equipment={item.equipment}
                            url={url}
                            equipmentList={equipmentList}
                            matchData={currentTabData.matchData}
                            submitUrl={submitUrl}
                            isTabbedData={isTabbedData}
                            activeTab={activeTab}
                            fetchEquipmentList={fetchEquipmentList}
                            itemAdded={(newMachineryName, uniqueIds) =>
                              handleItemAdded(index, newMachineryName, uniqueIds)
                            }
                            title={title}
                            setsnackOpen={setsnackOpen}
                          />
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Document Upload Section */}
          <Box
            sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Document Upload
            </Typography>
            <Box>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Do you want to upload document?
                </FormLabel>
                <RadioGroup
                  value={
                    documentUploadConfirmed[
                      activeTab === 0 ? "cumulative" : "individual"
                    ]
                      ? "yes"
                      : "no"
                  }
                  onChange={(e) =>
                    handleDocumentUploadConfirmation(e.target.value === "yes")
                  }
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            {documentUploadConfirmed[
              activeTab === 0 ? "cumulative" : "individual"
            ] && (
              <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
                <FormLabel component="legend">Document Upload Type</FormLabel>
                <RadioGroup
                  value={
                    documentUploadType[
                      activeTab === 0 ? "cumulative" : "individual"
                    ]
                  }
                  onChange={handleDocumentUploadTypeChange}
                  row
                >
                  {/* <FormControlLabel value="none" control={<Radio />} label="No Document Upload" /> */}
                  <FormControlLabel
                    value="same"
                    control={<Radio />}
                    label="Same File for All Records"
                  />
                  <FormControlLabel
                    value="individual"
                    control={<Radio />}
                    label="Individual File for Each Record"
                  />
                </RadioGroup>
              </FormControl>
            )}

            {documentUploadConfirmed[
              activeTab === 0 ? "cumulative" : "individual"
            ] &&
              documentUploadType[
                activeTab === 0 ? "cumulative" : "individual"
              ] === "same" && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Upload a single document that will be associated with all
                    records:
                  </Typography>
                  <BulkFileUpload
                    filesList={
                      commonDocument[
                        activeTab === 0 ? "cumulative" : "individual"
                      ]
                    }
                    handleChange={handleCommonDocumentChange}
                    handleClear={handleClearCommonDocument}
                  />
                </Box>
              )}

            {documentUploadConfirmed[
              activeTab === 0 ? "cumulative" : "individual"
            ] &&
              documentUploadType[
                activeTab === 0 ? "cumulative" : "individual"
              ] === "individual" && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Upload individual documents for each record. Documents will
                    be added as a new column in the table above.
                  </Typography>
                </Box>
              )}
          </Box>

          {/* Validation Error Display - Only show after validation has been attempted */}
          {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#ffebee",
                borderRadius: 1,
                border: "1px solid #f44336",
              }}
            >
              <Typography
                variant="h6"
                color="error"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Error:
              </Typography>
              {uploadValidationErrors.map((error, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  color="error"
                  sx={{ mb: 0.5 }}
                >
                  • {error}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={!confirmButtonEnabled}
          >
            Confirm Upload
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog for Proceeding Without Documents */}
      <Dialog
        open={showNoDocumentDialog}
        onClose={handleCancelProceedWithoutDocuments}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">No Documents Uploaded</Typography>
            <IconButton
              onClick={handleCancelProceedWithoutDocuments}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You have selected to upload documents but haven't uploaded any files
            for:
          </Typography>
          <Box sx={{ mb: 2 }}>
            {tabsNeedingConfirmation.cumulative && (
              <Typography
                variant="body2"
                sx={{ mb: 1, fontWeight: "bold", color: "#1976d2" }}
              >
                • Cumulative Data Entry
              </Typography>
            )}
            {tabsNeedingConfirmation.individual && (
              <Typography
                variant="body2"
                sx={{ mb: 1, fontWeight: "bold", color: "#1976d2" }}
              >
                • Individual Data Entry
              </Typography>
            )}
          </Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Do you want to proceed without uploading documents for these tabs?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can still upload documents later if needed.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={handleCancelProceedWithoutDocuments}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Upload Documents
          </Button>
          <Button
            onClick={handleProceedWithoutDocuments}
            variant="contained"
            color="primary"
          >
            Proceed Without Documents
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkUpload;
